<script>
  import moment from "moment";
  import { stringify } from "query-string";
  import { navigate } from "svelte-routing";
  import { Head, Body, Row, Cell } from "@smui/data-table";
  import ResourceList from "../components/ResourceList.svelte";
  import { ResourceSelect, ResourceOption } from "../components";
  import Checkbox from "@smui/checkbox";
  import Button from "@smui/button";
  import { Icon, Label } from "@smui/common";
  import FormField from "@smui/form-field";
  import { exclude } from "@smui/common/exclude.js";

  export let title;
  export let location;
  export let basePath = "/popups";
  export let vendorId = null;
  export let venueId = null;
  export let topLevel = true;

  export let statuses = ["proposed", "scheduled", "completed"];
  title = "Events";

  let records;
  let list;
  let filter = { status: statuses };
  let sort = [];
  let forVendor = vendorId !== null;
  let forVenue = venueId !== null;
  if (vendorId) {
    filter.vendor_id = vendorId;
  }
  if (venueId) {
    filter.venue_id = venueId;
  }

  $: props = exclude($$props, ["vendorId", "venueId", "statuses", "title"]);

  function changeFilter(event) {
    if (!event.target.name) {
      console.log("Filter name not set");
    } else {
      console.log("Change filter: ", event.target.name, event);
      if (event.target.value) {
        filter[event.target.name] = event.target.value;
      } else {
        delete filter[event.target.name];
      }
      list.refresh({ filter });
    }
  }

  function changeStatusFilter(event) {
    filter.status = statuses;
    list.refresh({ filter });
  }

  function create() {
    let query = `${basePath}/create`;
    if (Object.keys(filter).length > 0) {
      query += "?" + stringify(filter);
    }
    console.log("query: ", query);
    navigate(query);
  }

  function edit(id) {
    console.log(`Edit ${basePath}/${id}`);
    navigate(`${basePath}/${id}`);
  }

  function setSort(col) {
    const [sortCol, sortDir] = sort;
    if (col != sortCol) {
      sort = [col, "asc"];
    } else {
      sort = [col, sortDir === "asc" ? "desc" : "asc"];
    }
    console.log(`Sort now: ${sort}`);
    list.refresh({ sort });
  }

  function perHead(row) {
    if (row.catered_value && row.meal_prep) {
      return row.catered_value / row.meal_prep;
    } else {
      return "";
    }
  }
</script>

<style type="text/scss">
  .status.proposed {
    font-weight: bold;
    color: darkorange;
  }

  .status.scheduled {
    font-weight: bold;
    color: darkgreen;
  }

  .status.completed {
    font-weight: bold;
  }
  .inline {
    display: inline;
  }
</style>

{(console.log('PopupList.filter: ', filter), '')}
<ResourceList
  resource="popups"
  bind:this={list}
  {location}
  bind:records
  title={topLevel ? null : title}
  {filter}
  {sort}
  {create}
  {...props}>
  <div slot="filters" class="flex wrap no-spread">
    {#if !forVenue}
      <ResourceSelect
        input$name="venue_id"
        on:change={changeFilter}
        bind:value={venueId}
        resource="venues"
        filter={{ has_popup: true }}
        nameField="venue_name"
        label="Venue" />
    {/if}
    {#if !forVendor}
      <ResourceSelect
        input$name="vendor_id"
        on:change={changeFilter}
        bind:value={vendorId}
        resource="vendors"
        filter={{ has_popup: true }}
        nameField="vendor_name"
        label="Vendor" />
    {/if}
    <div class="flex wrap">
      {#each ['proposed', 'scheduled', 'completed', 'cancelled'] as status}
        <FormField>
          <Checkbox
            bind:group={statuses}
            value={status}
            on:change={changeStatusFilter} />
          <span slot="label">{status}</span>
        </FormField>
      {/each}
    </div>
  </div>
  <div slot="actions" let:loading>
    {(console.log(`PopupList actions, loading ${loading}`), '')}
    <span class="fd-list-actions">
      <Button on:click={create} class="create-button" disabled={loading}>
        <Icon class="material-icons">add</Icon>
        <Label>create</Label>
      </Button>
    </span>
  </div>
  <Head>
    <Row>
      <Cell class="pointer" on:click={() => setSort('start_time')}>Date</Cell>
      <Cell class="pointer" on:click={() => setSort('popup_type')}>Style</Cell>
      <Cell>
        {#if !forVenue}
          Venue
          <br />
        {/if}
        {#if !forVendor}Vendor{/if}
      </Cell>
      <Cell>Info</Cell>
    </Row>
  </Head>
  <Body>
    {#if records}
      {#each records as row}
        <Row on:click={() => edit(row.id)} class="pointer mdc-data-table__row">
          <Cell>
            {moment(row.start_time).format('Do MMM, HH:mm')}
            <br />
            <span class="status {row.status}">{row.status}</span>
          </Cell>
          <Cell>
            {#if row.popup_type === 'popup'}
              <i class="material-icons" title={row.popup_type}>storefront</i>
            {:else if row.popup_type == 'catered'}
              <i class="material-icons" title={row.popup_type}>room_service</i>
            {/if}
          </Cell>
          <Cell>
            {#if !forVenue}
              {row.venue_name}
              <br />
            {/if}
            {#if !forVendor}{row.vendor_name || '-'}{/if}
          </Cell>
          <Cell>
            {#if row.popup_type === 'popup'}
              {#if row.status == 'proposed' || !row.sales_summary.total_takings}
                (est {row.meal_prep})
              {:else}
                <span>Sales: £{row.sales_summary.total_takings}</span>
                <br />
                <span>Commission: £{row.sales_summary.total_commission}</span>
              {/if}
            {:else if row.popup_type == 'catered'}
              <span>{row.description}</span>
              <br />
              <span>
                Total: £{row.catered_value} ({row.vat_inclusive ? 'incl' : 'excl'}
                VAT)
              </span>
            {/if}
          </Cell>
        </Row>
      {/each}
    {/if}
  </Body>
</ResourceList>
